import React from 'react';
import './ScreenSlider.css'
import HistoryScreen from '../../Components/Common/HistoryScreen';
import CardImg from '../../Components/Common/CardImg';

import Card1Img1 from '../../Assets/Card1/1.png'
import Card1Img2 from '../../Assets/Card1/2.png'
import Card1Img3 from '../../Assets/Card1/3.png'
import Card1Img4 from '../../Assets/Card1/4.png'

import Card2Img1 from '../../Assets/card2/1.png'
import Card2Img2 from '../../Assets/card2/2.png'
import Card2Img3 from '../../Assets/card2/3.png'


import Card3Img1 from '../../Assets/Card3/1.png'
import Card3Img2 from '../../Assets/Card3/2.png'
import Card3Img3 from '../../Assets/Card3/3.png'

import Card4Img1 from '../../Assets/Card4/1.png'
import Card4Img2 from '../../Assets/Card4/2.png'

const ScreenSlider = () => {
    return ( 
        <>
        <div className='ScreensContainer'>
                    <div className='Screen1'>
                        <CardImg ImgSrc={Card1Img1} ImgStyle="Card1Img1"/>
                        <CardImg ImgSrc={Card1Img2} ImgStyle="Card1Img2"/>
                        <CardImg ImgSrc={Card1Img3} ImgStyle="Card1Img3"/>
                        <CardImg ImgSrc={Card1Img4} ImgStyle="Card1Img4"/>
                        <HistoryScreen Year="427 BCE" Event="Birth in Athens" Desc="Plato was born in Athens around 427 BCE into a wealthy and politically influential family. His relatives were involved in Athenian politics, exposing him early to the world of leadership, governance, and public life that would later influence his philosophical writings." />
                    </div>
                    <div className='Screen2'>
                        <CardImg ImgSrc={Card2Img1} ImgStyle="Card2Img1"/>
                        <CardImg ImgSrc={Card2Img2} ImgStyle="Card2Img2"/>
                        <CardImg ImgSrc={Card2Img3} ImgStyle="Card2Img3"/>
                        <HistoryScreen Year="407 BCE" Event="Student of Socrates" Desc="As a young man, Plato became a devoted student of the philosopher Socrates. Socrates’ method of questioning and debate deeply shaped Plato’s thinking and inspired him to pursue philosophy rather than politics." />
                    </div>
                    <div className='Screen3'>
                        <CardImg ImgSrc={Card3Img1} ImgStyle="Card3Img1"/>
                        <CardImg ImgSrc={Card3Img2} ImgStyle="Card3Img2"/>
                        <CardImg ImgSrc={Card3Img3} ImgStyle="Card3Img3"/>
                        <HistoryScreen Year="399 BCE" Event="Execution of Socrates" Desc="Socrates was sentenced to death by the Athenian government for allegedly corrupting the youth and challenging traditional beliefs. The execution profoundly affected Plato and convinced him that the political system in Athens was flawed, pushing him further toward philosophy." />
                    </div>
                    <div className='Screen4'>
                        <CardImg ImgSrc={Card4Img1} ImgStyle="Card4Img1"/>
                        <CardImg ImgSrc={Card4Img2} ImgStyle="Card4Img2"/>
                        <HistoryScreen Year="387 BCE" Event="Founding of the Academy" Desc="After traveling and studying for several years, Plato returned to Athens and founded the Academy, one of the earliest institutions dedicated to philosophical study. The school later taught many influential thinkers, including Aristotle." />
                    </div>
                </div>
        </>
     );
}
 
export default ScreenSlider;